export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';



// WEBPACK FOOTER //
// ./src/core/notification/action-types.js